import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Login',
    data () {
        return {
           admin:{},
           setForgetPasswordPanel:false,
           setResetPasswordPanel:false,
           setActionPanel: false,
           loading:false,
           disable_btn: false,
           mod_message: "nill"
        }
    },
    components: {
        'second-header': SecondHeader,
        'main-footer': MainFooter
    },
    methods: {
        setComponent(attr1,attr2){
            if(attr1 == "set_forgot"){
                this.setActionPanel = true;
                this.setForgetPasswordPanel =  true;
            }
        },
        reset() {
            localStorage.removeItem("cityneeds_a_user");
            localStorage.removeItem("cityneeds_a_token");
            localStorage.removeItem("cityneeds_a_token_key");
            //remove session key here linked to session well @server
            let navi = this.$router;
            if(this.$route.query.resetPassword){
                service.verifyResetToken(this, this.$route.query.resetPassword).then(response => {
                    if(response.status == 200) {
                        this.setActionPanel = true;
                        this.setResetPasswordPanel = true;
                        this.admin.user_id = response.body.data;
                        navi.push('login');
                    }
                }).catch((err) => {
                    toastr.warning("Authentication Failed", 'Warning!'); 
                    if(err.status == 400) {
                        this.mod_message = "Something went wrong with the process, please try again";
                      }else{
                        navi.push('login');
                    }
                })
            }else{
                navi.push('login');
            }
        },
        login() {
            this.disable_btn = true;
            this.loading = true;
            var credentials = {
                admin_email: this.admin.email,
                admin_password: this.admin.password,
            }
            let navi = this.$router;
            if(credentials.admin_email == null || credentials.admin_email == undefined || credentials.admin_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else if(credentials.admin_password == null || credentials.admin_password == undefined || credentials.admin_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            }else {
               service.loginAdmin(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                         data.forEach(function(element) {
                            localStorage.setItem("cityneeds_a_user", element.admin_fullname);
                            localStorage.setItem("cityneeds_a_token", element.admin_session_key); //store session key here linked to session well @server
                            localStorage.setItem("cityneeds_a_token_key", element.admin_token_key); 
                        }, this);
                        navi.push('dashboard');
                    }else{
                        toastr.warning("invalid login credentials", 'Warning!'); 
                        this.disable_btn = false;
                        this.loading = false;
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid login credentials", 'Warning!'); 
                        this.disable_btn = false;
                    }
                })
            }
        },

        
        forgotPassword() {
            this.disable_btn = true;
            this.loading = true;
            var credentials = {
                email: this.admin.email,
            }

            if(credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else {
                service.forgotPassword(this, credentials).then((response) => {
                    if(response.status == 200) {
                      this.mod_message = "Request sent, please check your mail to reset password";
                      this.admin = {};
                      this.setForgetPasswordPanel = false;
                      this.disable_btn = false;
                      this.loading = false;
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("Email not valid", 'Warning!'); 
                    }
                    this.disable_btn = false;
                    this.loading = false;
                })
            }
        },

        resetPassword() {
            var credentials = {
                new_password: this.admin.new_password,
                confirm_password: this.admin.confirm_password,
                user: this.admin.user_id
            }
            let navi = this.$router;
            if(credentials.new_password == '' || credentials.confirm_password == '' ) {
               toastr.warning("Kindly enter password", 'Warning!');
            }else if(credentials.new_password != credentials.confirm_password ) {
                toastr.warning("Passwords does not match", 'Warning!');
            }else {
                service.resetForgotPassword(this, credentials).then((response) => {
                    if(response.body.status == 200) {
                         this.can_reset = false;
                         this.can_login = true; 
                         toastr.success("Password has been Reset", 'Changed!'); 
                         navi.push('login');
                    }  
                   }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!'); 
                    }
                })
            }
        },

  },
  created: function() {
    this.reset();
  }
}


// WEBPACK FOOTER //
// ./src/components/Login/script.js